import { Scale } from '@blade/common/utils/auto-scale';
import { get, merge } from 'lodash';
import { Legend_Config, Tooltip_Config, AxisConfig } from '@blade-sxp/portrait-center/utils/common-config';
import colors from '@/styles/color.scss';
const formatter = (propeties) => {
    const value = get(propeties, 'value', '');
    return Number(value) > 0 ? value : '';
};
const LabelConfig = {
    show: false,
    position: 'insideRight',
    color: colors.portraitCenterBarhConfigInside,
    fontSize: 13 * Scale,
    formatter,
};
export const barhOption = (vue) => {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            ...Tooltip_Config,
            backgroundColor: colors.white,
            className: 'echarts-tooltip echarts-tooltip-white',
        },
        legend: {
            data: [vue.$t('ST_ADULT'), vue.$t('ST_OLD'), vue.$t('ST_CHILD')],
            left: 0,
            textStyle: Legend_Config.textStyle,
            itemWidth: 10 * Scale,
            itemHeight: 10 * Scale,
            icon: 'circle',
            itemGap: 32,
        },
        dataZoom: [
            {
                type: 'inside',
                start: 0,
                minSpan: 1,
                end: 100
            },
            {
                type: 'slider',
                start: 0,
                end: 100,
                handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',
                handleSize: 9 * Scale,
                handleStyle: {
                    color: colors.white,
                    borderWidth: 3 * Scale,
                    borderColor: colors.portraitEchartBorder
                },
                backgroundColor: colors.portraitCenterCchartZoom,
                borderColor: 'none',
                height: 4 * Scale,
                left: 8 * Scale,
                right: 8 * Scale,
                bottom: 6 * Scale,
                fillerColor: colors.portraitEchartBorder,
                showDetail: false,
                showDataShadow: false,
                filterMode: 'empty',
                brushSelect: false, // 是否开启刷选功能,默认true
            },
        ],
        grid: {
            left: 0,
            top: 45 * Scale,
            right: 20 * Scale,
            bottom: 20 * Scale,
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            data: [],
            ...merge({}, AxisConfig, {
                axisLabel: {
                    interval: 'auto',
                    align: 'center',
                    formatter: (label) => label.slice(5),
                }
            }),
            axisLine: {
                show: false,
            }
        },
        yAxis: {
            type: 'value',
            data: [],
            ...AxisConfig,
            axisLine: {
                show: false,
            },
        },
        series: [
            {
                name: vue.$t('ST_ADULT'),
                type: 'bar',
                stack: '总量',
                label: LabelConfig,
                itemStyle: {
                    color: colors.portraitCenterBrightAgeModeDougnutOption,
                },
                data: [],
            },
            {
                name: vue.$t('ST_OLD'),
                type: 'bar',
                stack: '总量',
                label: LabelConfig,
                itemStyle: {
                    color: colors.portraitCenterBarhConfigSeriesAdult,
                },
                data: [],
            },
            {
                name: vue.$t('ST_CHILD'),
                type: 'bar',
                stack: '总量',
                label: LabelConfig,
                itemStyle: {
                    color: colors.portraitCenterBarhConfigSeries,
                },
                data: [],
            },
        ],
    };
};
